/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index badge to autogenerate all the components and extensions
 * Used by "prepareBadges"
 */

import Badge from './badge/Badge'
export * from './badge/Badge'
export default Badge
